<template>
  <el-dialog
    :visible="visible"
    title="Спасибо!"
    append-to-body
    custom-class="register-success-modal"
    :show-close="false"
    @close="closeHandler"
  >
    <h2 class="register-success-modal__title">Запрос успешно отправлен.</h2>
    <p class="register-success-modal__message">
      Дождитесь консультации либо сразу перейдите к заполнению вторичной анкеты
    </p>
    <el-button
      type="success"
      class="register-success-modal__button"
      @click="$router.push({ name: 'register-step-two' })"
      >Продолжить</el-button
    >
  </el-dialog>
</template>

<script>
export default {
  name: 'RegisterStepOneModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    closeHandler() {
      this.$emit('update:visible', false)
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
.register-success-modal {
  width: 480px;

  @include sm-and-down {
    width: 100%;
  }

  &__title {
    font-size: 24px;
    text-align: center;
    letter-spacing: 0.35px;
    color: $deepdark;
    font-weight: normal;
    margin-bottom: 16px;
  }

  &__message {
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: $french-gray;
    margin-bottom: 50px;
  }

  &__button {
    margin: 0 auto;
    font-size: 18px;
    display: block;
  }

  .el-dialog {
    &__title {
      text-transform: uppercase;
    }

    &__header {
      padding: 24px 18px 48px;
    }
  }
}
</style>
